import { useState, useEffect } from "react";
import { subscribeMediaQuery } from "../utils/mediaQuery";

export function useMediaQuery(query) {
	const [matches, setMatches] = useState(false);

	useEffect(() => {
		const media = window.matchMedia(query);

		if (media.matches !== matches) {
			setMatches(media.matches);
		}

		const listener = () => setMatches(media.matches);
		return subscribeMediaQuery(media, listener);
	}, [matches, query]);

	return matches;
}
